import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import "../styles/components/categorie.scss";
import Footer from '../components/footer';
import Header from '../components/header';
const Categorie = () => {
	const [data, setData] = useState([]);
	const { idGenre, categoryName } = useParams();
	const [page, setPage] = useState(1);
	const history = useHistory();

	useEffect(() => {
		console.log("idGenre:", idGenre);
		if (idGenre) {
			axios
				.get(
					`https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_TMDB_API_KEY}&language=fr-FR&with_genres=${idGenre}&page=${page}`
				)
				.then((res) => {
					console.log("Data loaded:", res.data.results);
					setData(res.data.results);
				})
				.catch((error) =>
					console.error("Erreur lors de la récupération des films :", error)
				);
		}
	}, [idGenre, page]);

	return (
		<div>
			<Header />
			<header className="header_categorie_1">
				<h1>
					{categoryName
						? decodeURIComponent(categoryName)
						: idGenre
						? "Catégorie"
						: "Aucune catégorie sélectionnée"}
				</h1>
				<div className="categorie-container">
					<div className="row">
						{data.length > 0 ? (
							data.map((p) => (
								<div
									className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4 col-xl-3 col-xxl-2"
									key={p.id}>
									<div
										onClick={() => history.push(`/movieDetails/${p.id}`)}
										className="container">
										<div className="movie-card">
											<div className="poster">
												<img
													className="card__image"
													src={`https://image.tmdb.org/t/p/original/${p.poster_path}`}
													alt={`photo-film-${p.title}`}
												/>
											</div>
											<div className="details">
												<div className="tags">
													<span>{p.release_date}</span>
												</div>
												<div className="description">
													<p>{p.overview}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							))
						) : (
							<p>Aucun film trouvé pour cette catégorie.</p>
						)}
            <div className="btn-container">
                <button onClick={() => setPage(1)}>Go to first</button>
                <button onClick={() => {
                    (page == 1) ? (window.alert("No previous page")) : (setPage(page - 1))
                }}>Previous</button>
                <button onClick={(() => {
                    (page == 500) ? (window.alert("No next page")) : (setPage(page + 1))
                })}>Next</button>
                <button onClick={() => setPage(500)}>Go to last</button>
            </div>
					</div>
				</div>
			</header>
			<Footer />
		</div>
	);
};

export default Categorie;
